/**
 * Cross-UI session handoff between this old UI (served at /) and the new UI
 * (served at /beta) on the same origin (dev.paymentoptions.com).
 *
 * This app writes its login payload to a shared localStorage key whenever the
 * profile is set (login / refresh / sign-up / reset-password). The new UI reads
 * it on bootstrap so /beta does not bounce to its login screen after the user
 * has logged in here. Cleared on logout.
 */
const KEY = 'das.session.v1';

export function writeSharedSession(profile: any): void {
  try {
    if (profile?.token?.idToken) {
      window.localStorage.setItem(KEY, JSON.stringify(profile));
    }
  } catch (e) {
    /* localStorage unavailable — ignore */
  }
}

export function clearSharedSession(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch (e) {
    /* ignore */
  }
}
